<template>
	<modal v-model="deleting" :disabled="loading">
		<template v-slot:header><h3>Delete {{ (deleting)?deleting[display || 'name']:'' }}</h3></template>
		<loader :loading="loading"></loader>
		<p>Are you sure you really wish to delete {{ (deleting && deleting[display || 'name'])?deleting[display || 'name']:'this item' }}?</p>
		<template v-slot:footer>
			<icon-button icon="essentials/alerts/cancel" class="warning" @click="deleting = null" :disabled="loading">Cancel</icon-button>
			<icon-button icon="essentials/basics/check-circle" class="danger" @click="startRemove" :disabled="loading">Delete</icon-button>
		</template>
	</modal>
</template>

<script>
	export default {
		props: ['value', 'remove', 'display'],
		data() {
			return {
				deleting: this.value,
				loading: false
			};
		},
		watch: {
			deleting() {
				this.$emit('input', this.deleting);
			},
			value() {
				this.deleting = this.value;
			}
		},
		methods: {
			async startRemove() {
				this.loading = true;
				try {
					await this.remove();
					this.deleting = null;
				} catch(e) {}
				this.loading = false;
			}
		}
	}
</script>